module.exports = __webpack_public_path__ + "img/ic-huiyi.b238bf98.png";